import React from 'react';
import { AutoSizer, Collection } from 'react-virtualized';
import 'react-virtualized/styles.css';
import PropTypes from 'prop-types';
import { LIST } from '../constants/art';

export const Gallery = ({ mode }) => {
	const list = (() => {
		switch (mode) {
		case 'jugaad':
			return LIST.jugaad;
		case 'chindogu':
			return LIST.chindogu;
		default:
			return LIST.default;
		}
	})();

	const cellRenderer = ({ index, key, style }) => (
		<img key={key} style={style} src={list[index].src} alt="logo" />
	);

	const cellSizeAndPositionGetter = ({ index }) => {
		const datum = list[index];

		return {
			height: datum.height,
			width: datum.width,
			x: datum.x ?? (datum.width + 50) * index,
			y: datum.y,
		};
	};
	return (
		<AutoSizer disableHeight>
			{({ width }) => (
				<Collection
					cellCount={list.length}
					cellRenderer={cellRenderer}
					cellSizeAndPositionGetter={cellSizeAndPositionGetter}
					height={800}
					width={width}
				/>
			)}
		</AutoSizer>
	);
};
Gallery.propTypes = {
	mode: PropTypes.string,
};

Gallery.defaultProps = {
	mode: '',
};

export default Gallery;
